/**
 * Services/Dienstleistungen Daten
 */

export const servicesData = [
  {
    id: 1,
    slug: 'hausmeisterservice',
    title: 'Hausmeisterservice',
    shortDescription: 'Professionelle Gebäudebetreuung und Instandhaltung für Wohn- und Gewerbeimmobilien.',
    fullDescription: 'Als Ihr zuverlässiger Hausmeister kümmern wir uns um alle anfallenden Arbeiten in und um Ihr Gebäude. Von der regelmäßigen Wartung bis zur schnellen Störungsbeseitigung – wir sind Ihr kompetenter Ansprechpartner.',
    icon: 'Building',
    features: [
      'Regelmäßige Kontrollgänge und Wartung',
      'Kleine Reparaturen und Instandsetzungen',
      'Winterdienst und Streupflicht',
      'Garten- und Außenanlagenpflege',
      'Mülltonnen-Management',
      'Koordination von Fachhandwerkern',
      'Notdienst-Verfügbarkeit',
    ],
    benefits: [
      'Eine Ansprechperson für alle Belange',
      'Schnelle Reaktionszeiten',
      'Faire, transparente Preise',
      'Langjährige Erfahrung',
    ],
    image: '/images/service-hausmeister.jpeg',
    ctaText: 'Hausmeister anfragen',
  },
  {
    id: 2,
    slug: 'gebaeudereinigung',
    title: 'Gebäudereinigung',
    shortDescription: 'Gründliche Reinigung von Büros, Treppenhäusern und Gewerbeflächen.',
    fullDescription: 'Sauberkeit schafft Wohlbefinden und einen professionellen Eindruck. Wir bieten Ihnen eine umfassende Gebäudereinigung nach höchsten Standards – zuverlässig, gründlich und umweltbewusst.',
    icon: 'Sparkles',
    features: [
      'Büroreinigung und Unterhaltsreinigung',
      'Treppenhausreinigung',
      'Glas- und Fensterreinigung',
      'Sanitärreinigung',
      'Grundreinigung und Baureinigung',
      'Teppich- und Bodenreinigung',
      'Desinfektionsmaßnahmen',
    ],
    benefits: [
      'Umweltfreundliche Reinigungsmittel',
      'Flexible Reinigungszeiten',
      'Qualifiziertes Personal',
      'Höchste Hygienestandards',
    ],
    image: '/images/service-reinigung.jpeg',
    ctaText: 'Reinigungstermin vereinbaren',
  },
  {
    id: 3,
    slug: 'entruempelung',
    title: 'Entrümpelung',
    shortDescription: 'Fachgerechte Entrümpelung von Wohnungen, Kellern, Garagen und Gewerbeflächen.',
    fullDescription: 'Ob Haushaltsauflösung, Kellerentrümpelung oder die Räumung von Gewerbeflächen – wir erledigen die komplette Entrümpelung fachgerecht, schnell und zu fairen Konditionen.',
    icon: 'Package',
    features: [
      'Haushaltsauflösungen',
      'Keller- und Dachbodenentrümpelung',
      'Garagen- und Schuppenräumung',
      'Gewerbeflächen-Räumung',
      'Nachlass-Regulierungen',
      'Besenreine Übergabe',
      'Wertanrechnung bei Verkaufswerten',
    ],
    benefits: [
      'Schnelle Terminvergabe',
      'Feste Preiszusagen',
      'Diskrete und einfühlsame Arbeitsweise',
      'Professionelles Team',
    ],
    image: '/images/service-entruempelung.jpeg',
    ctaText: 'Entrümpelung anfragen',
  },
  {
    id: 4,
    slug: 'entsorgung',
    title: 'Entsorgung',
    shortDescription: 'Umweltgerechte Entsorgung von Sperrmüll, Bauschutt und Gewerbeabfällen.',
    fullDescription: 'Wir kümmern uns um die fachgerechte und umweltbewusste Entsorgung aller Arten von Abfällen. Mit den richtigen Entsorgungsnachweisen und Zertifikaten für Ihre Dokumentation.',
    icon: 'Trash2',
    features: [
      'Sperrmüllentsorgung',
      'Bauschuttentsorgung',
      'Gewerbeabfall-Entsorgung',
      'Elektrogeräte-Entsorgung',
      'Grünschnitt-Entsorgung',
      'Container-Stellung möglich',
      'Entsorgungsnachweise',
    ],
    benefits: [
      '100% gesetzeskonform',
      'Umweltgerechte Verwertung',
      'Alle notwendigen Nachweise',
      'Flexible Abholtermine',
    ],
    image: '/images/service-entsorgung.jpeg',
    ctaText: 'Entsorgung planen',
  },
];

export const serviceCategories = [
  { id: 'all', label: 'Alle Leistungen' },
  { id: 'hausmeisterservice', label: 'Hausmeister' },
  { id: 'gebaeudereinigung', label: 'Reinigung' },
  { id: 'entruempelung', label: 'Entrümpelung' },
  { id: 'entsorgung', label: 'Entsorgung' },
];
